import {FontLibrary} from "cartovista";
import {show} from "cartovistaExtend/appTools/Alerts";
import {queryLayer} from "cartovistaExtend/utils/ServerRequests";
import {  createFeatures,  createDataRows, drawStyleIconCanvas, createStyle} from "cartovistaExtend/utils/CvUtils";
import ResultsList from "cartovistaExtend/panels/Results/ResultsList";
import { Popover } from 'bootstrap';
import "styles/QueryCpAdrs.css";﻿

const responsiveBtn = '<span id="cv-responsiveBtnQueryCpAdrsView"></span>';
const responsiveViewContainer = '<div id="cv-responsiveQueryCpAdrsView" class="cv-responsiveViewContainer"></div>';
const genericView = '<div data-cv-role="genericView" id="QueryCpAdrs_panel" data-cv-active="true" data-cv-responsiveTarget="cv-responsiveQueryCpAdrsView"></div>';
const btnToggleGenericView = '<button data-cv-role="btnToggleGenericView" id="QueryCpAdrs_panel_btn" data-cv-toggleGroup="topSidebarGroup" data-cv-associatedContainer="QueryCpAdrs_panel" data-cv-responsiveTarget="cv-responsiveBtnQueryCpAdrsView"></button>';

const queryCpAdrsBtnHtml = '<span class="cv-icon"><i class="bi bi-star-fill"></i></span>';

const queryToolPanelHtml = '<div id="QueryCpAdrs_container">' +
                                    '<ul class="nav nav-tabs" role="tablist">' +
                                        '<li class="nav-item" role="presentation"><a class="nav-link active" href="#QueryCpAdrs_cp_tab" aria-controls="QueryCpAdrs_queryCpTab" role="tab" data-bs-toggle="tab"><canvas id="QueryCpAdrs_canvas_cp" style="float:left;"></canvas>&nbsp;Codes postaux</a></li>' +
                                        '<li class="nav-item" role="presentation"><a class="nav-link" href="#QueryCpAdrs_adrs_tab" aria-controls="QueryCpAdrs_queryAdrsTab" role="tab" data-bs-toggle="tab"><canvas id="QueryCpAdrs_canvas_adrs" style="float:left;"></canvas>&nbsp;Points d\'adresses</a></li>' +
                                    '</ul>' +
                                    '<div class="tab-content">' +
                                        '<div role="tabpanel" class="tab-pane active" id="QueryCpAdrs_cp_tab">' +
                                            '<div class="accordion">' +
                                                '<div class="accordion-item">' +
                                                    '<h2 class="accordion-header">' +
                                                        '<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#QueryCpAdrs_cp_panelBody" aria-expanded="true" aria-controls="QueryCpAdrs_cp_panelBody">Charger des codes postaux</button>' +
                                                    '</h2>' +
                                                    '<div id="QueryCpAdrs_cp_panelBody" class="InfoModal-collapse accordion-collapse collapse show">' +
                                                        '<div class="accordion-body">' +
                                                            '<form id="QueryCpAdrs_cp_form" role="form">' +
                                                                '<div class="form-group">' +
                                                                    '<label for="QueryCpAdrs_cp_selectByFieldInput" class="form-label">Par</label>' +
                                                                    '<select id="QueryCpAdrs_cp_selectByFieldInput" class="form-select form-control">' +
                                                                        '<option field-id="CD_POSTL" checkBoxInput="true" href="#" placeholder="ex.: G0A0E3, G0A1A0, G0A1B0, ...">Code postal</option>' +
                                                                        '<option field-id="CD_MUNCP" href="#" placeholder="ex.: 01023, 01042, 02005, ...">Code de municipalité</option>' +
                                                                        '<option field-id="CD_CS_FRA" href="#" placeholder="ex.: 711000, 712000, 713000, ...">Code CSS francophone</option>' +
                                                                        '<option field-id="CD_CS_ANG" href="#" placeholder="ex.: 881000, 882000, 883000, ...">Code CS anglophone</option>' +
                                                                        '<option field-id="CD_CS_STA" href="#" placeholder="ex.: 689000, 759000, 769000">Code CSS ou CS à statut particulier</option>' +
                                                                        '<option field-id="CD_SECTR_FRA" showNotice="true" href="#" placeholder="ex.: 711A, 71201, 71301, ...">Code de secteur francophone*</option>' +
                                                                        '<option field-id="CD_SECTR_ANG" showNotice="true" href="#" placeholder="ex.: 88104, 88201, 88301, ...">Code de secteur anglophone*</option>' +
                                                                        '<option field-id="CD_SECTR_STA" showNotice="true" href="#" placeholder="ex.: 689A, 75901, 76901, ...">Code de secteur à statut particulier*</option>' +
                                                                        '<option field-id="DT_CRETN_CD_POSTL" stripChar="true" href="#" placeholder="ex.: 2010-01-01, AAAA-MM-JJ, ...">Date de création</option>' +
                                                                        '<option field-id="DT_RETRT_CD_POSTL" stripChar="true" href="#" placeholder="ex.: 2010-01-01, AAAA-MM-JJ, ...">Date de retrait</option>' +
                                                                    '</select>' +
                                                                '</div>' +
                                                                '<div class="form-group">' +
                                                                    '<label for="QueryCpAdrs_cp_selectByValuesInput" class="form-label">Valeurs</label>' +
                                                                    '<input type="text" id="QueryCpAdrs_cp_selectByValuesInput" class="form-control", placeholder="ex.: G0A0E3, G0A1A0, G0A1B0, ..."></input>' +
                                                                '</div>' +
                                                                '<div class="form-group">' +
                                                                    '<input class="form-check-input" type="checkbox" id="QueryCpAdrs_cp_loadAdrsInput" style="margin-top: 0px;">' +
                                                                    '<label class="form-check-label form-label" style="padding-left: 5px;" for="QueryCpAdrs_cp_loadAdrsInput">Charger les points d\'adresses associés</label>' +
                                                                '</div>' +
                                                                '<div class="d-grid justify-content-md-end">' +
                                                                    '<button type="submit" form="QueryCpAdrs_cp_form" class="btn btn-primary">Soumettre</button>'+
                                                                '</div>'+
                                                            '</form>' +
                                                            '<span id="QueryCpAdrs_cp_notice" style="display:none;">*&nbsp;<a href="#" id="QueryCpAdrs_cp_noticeLink">Note importante</a></span>' +
                                                        '</div>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div class="accordion">' +
                                                '<div class="accordion-item">' +
                                                    '<h2 class="accordion-header">' +
                                                        '<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#QueryCpAdrs_cp_resultsBody" aria-expanded="true" aria-controls="QueryCpAdrs_cp_resultsBody">Résultat(s)</button>' +
                                                    '</h2>' +
                                                    '<div id="QueryCpAdrs_cp_resultsBody" class="InfoModal-collapse accordion-collapse collapse show">' +
                                                        '<div class="accordion-body">' +
                                                            '<div id="QueryCpAdrs_cp_ResultsListContainer"></div>' +
                                                        '</div>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div role="tabpanel" class="tab-pane" id="QueryCpAdrs_adrs_tab">' +
                                            '<div class="accordion">' +
                                                '<div class="accordion-item">' +
                                                    '<h2 class="accordion-header">' +
                                                        '<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#QueryCpAdrs_adrs_panelBody" aria-expanded="true" aria-controls="QueryCpAdrs_adrs_panelBody">Charger des points d\'adresses</button>' +
                                                    '</h2>' +
                                                    '<div id="QueryCpAdrs_adrs_panelBody" class="InfoModal-collapse accordion-collapse collapse show">' +
                                                        '<div class="accordion-body">' +
                                                            '<form id="QueryCpAdrs_adrs_form" role="form">' +
                                                                '<div class="form-group">' +
                                                                    '<label for="QueryCpAdrs_adrs_selectByFieldInput" class="form-label">Par</label>' +
                                                                    '<select id="QueryCpAdrs_adrs_selectByFieldInput" class="form-select form-control">' +
                                                                        '<option field-id="CODPOS" checkBoxInput="true" href="#" placeholder="ex.: G0A0E3, G0A1A0, G0A1B0, ...">Code postal</option>' +
                                                                    '</select>' +
                                                                '</div>' +
                                                                '<div class="form-group">' +
                                                                    '<label for="QueryCpAdrs_adrs_selectByValuesInput" class="form-label">Valeurs</label>' +
                                                                    '<input type="text" id="QueryCpAdrs_adrs_selectByValuesInput" class="form-control", placeholder="ex.: G0A0E3, G0A1A0, G0A1B0, ..."></input>' +
                                                                '</div>' +
                                                                '<div class="form-group">' +
                                                                    '<input class="form-check-input" type="checkbox" id="QueryCpAdrs_adrs_loadCpInput" style="margin-top: 0px;">' +
                                                                    '<label class="form-check-label form-label" style="padding-left: 5px;" for="QueryCpAdrs_adrs_loadCpInput">Charger le code postal associé</label>' +
                                                                '</div>' +
                                                                '<div class="d-grid justify-content-md-end">' +
                                                                    '<button type="submit" form="QueryCpAdrs_adrs_form" class="btn btn-primary">Soumettre</button>'+
                                                                '</div>'+
                                                            '</form>' +
                                                        '</div>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div class="accordion">' +
                                                '<div class="accordion-item">' +
                                                    '<h2 class="accordion-header">' +
                                                        '<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#QueryCpAdrs_adrs_resultsBody" aria-expanded="true" aria-controls="QueryCpAdrs_adrs_resultsBody">Résultat(s)</button>' +
                                                    '</h2>' +
                                                    '<div id="QueryCpAdrs_adrs_resultsBody" class="InfoModal-collapse accordion-collapse collapse show">' +
                                                        '<div class="accordion-body">' +
                                                            '<div id="QueryCpAdrs_adrs_ResultsListContainer"></div>' +
                                                        '</div>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>';

export default class QueryCpAdrs {
    constructor() {
        $(".cv-responsiveBottomBar").prepend(responsiveBtn);
        $(".cv-responsiveBottomBar").after(responsiveViewContainer);
        $(".cv-right-top-pane").prepend(genericView);
        $("[data-cv-role='sidebar']").prepend(btnToggleGenericView);
        window.cartovista.addOneTimeEventListener(cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
        this._cpLayerConfig = C.LAYERS.GEO03E07_CP_REFRN;
        window.cartovista.addOneTimeEventListener(this._cpLayerConfig.LAYER_ID + "_layerCreated", this._onCpLayerCreated, this);
        this._adrsLayerConfig = C.LAYERS.GEO03E09_ADRS;
        window.cartovista.addOneTimeEventListener(this._adrsLayerConfig.LAYER_ID + "_layerCreated", this._onAdrsLayerCreated, this);
        this._$QueryCpAdrsPanel = $(queryToolPanelHtml);

        //cp form variables and event listeners
        this._$cpCanvas = this._$QueryCpAdrsPanel.find("#QueryCpAdrs_canvas_cp");
        this._$cpForm = this._$QueryCpAdrsPanel.find("#QueryCpAdrs_cp_form");
        this._$cpFieldInput = this._$QueryCpAdrsPanel.find("#QueryCpAdrs_cp_selectByFieldInput");
        this._$cpValuesInput = this._$QueryCpAdrsPanel.find("#QueryCpAdrs_cp_selectByValuesInput");
        this._$cpCheckboxInput = this._$QueryCpAdrsPanel.find("#QueryCpAdrs_cp_loadAdrsInput");
        this._$cpNotice = this._$QueryCpAdrsPanel.find("#QueryCpAdrs_cp_notice");
        _.forEach(this._$QueryCpAdrsPanel.find('#QueryCpAdrs_cp_noticeLink'), function(popover){
            new Popover(popover, {
                "title" : "Note importante",
                "content" : "Les codes de secteurs de la couche des codes postaux sont mis à jours une fois par mois. Il est possible que le résultat de la requête soit erroné si le découpage des secteurs a été modifié entre temps.",
                "placement" : "left",
                "container" : "body",
                "trigger" : "focus"
            });
          });
        this._formIsSubmitting = false;
        this._$cpForm.submit(this._onCpFormSubmitted.bind(this));
        this._$cpFieldInput.change(this._onCpFieldInputChanged.bind(this));

        //adrs form variables and event listeners
        this._$adrsCanvas = this._$QueryCpAdrsPanel.find("#QueryCpAdrs_canvas_adrs");
        this._$adrsForm = this._$QueryCpAdrsPanel.find("#QueryCpAdrs_adrs_form");
        this._$adrsFieldInput = this._$QueryCpAdrsPanel.find("#QueryCpAdrs_adrs_selectByFieldInput");
        this._$adrsValuesInput = this._$QueryCpAdrsPanel.find("#QueryCpAdrs_adrs_selectByValuesInput");
        this._$adrsCheckboxInput = this._$QueryCpAdrsPanel.find("#QueryCpAdrs_adrs_loadCpInput");
        this._$adrsForm.submit(this._onAdrsFormSubmitted.bind(this));
        this._$adrsFieldInput.change(this._onAdrsFieldInputChanged.bind(this));

        _.forEach(this._$QueryCpAdrsPanel.find('a[data-bs-toggle="tab"]'), function(tab){
            tab.addEventListener('shown.bs.tab', this._addCanvasSymbolsToTabs.bind(this));
        }.bind(this));
    };

    _onCpLayerCreated(evt) {
        var layer = this._map.getLayer(this._cpLayerConfig.LAYER_ID);
        this._cpResultsList = new ResultsList(this._$QueryCpAdrsPanel.find("#QueryCpAdrs_cp_ResultsListContainer"), layer, layer.getDataTable(this._cpLayerConfig.DATATABLE_ID));
    };

    _onAdrsLayerCreated(evt) {
        var layer = this._map.getLayer(this._adrsLayerConfig.LAYER_ID);
        this._adrsResultsList = new ResultsList(this._$QueryCpAdrsPanel.find("#QueryCpAdrs_adrs_ResultsListContainer"), layer, layer.getDataTable(this._adrsLayerConfig.DATATABLE_ID));
    };

    _onCartoVistaMapLoaded(evt) {
        this._map = window.cartovista.getMap(C.MAP.ID);
        this._mapController = window.cartovista.getMapController(this._map);
        $("#QueryCpAdrs_panel_btn").html(queryCpAdrsBtnHtml);
        window.cartovista.getUIController(this._map).findInstance("QueryCpAdrs_panel").activate();
        $("#QueryCpAdrs_panel").html(this._$QueryCpAdrsPanel);
        this._addCanvasSymbolsToTabs();
        window.cartovista.resizeRightVerticalSplitter(350);
    };

    _addCanvasSymbolsToTabs() {
        _.forEach([this._cpLayerConfig, this._adrsLayerConfig], function(layerConfig) {
            //wait the font to be loaded/ready
            new Promise(function(resolve, reject) {
                var font = FontLibrary.getFont(layerConfig.STYLES[0].SYMBOLIZERS[0].FONT_NAME);
                if (!font || !font.ready) {
                    FontLibrary.addOneTimeEventListener(FontLibrary.EVENTS.FONT_READY + "_" + layerConfig.STYLES[0].SYMBOLIZERS[0].FONT_NAME, resolve);
                } else {
                    resolve();
                }
            }).then(function() {
                var $canvas = layerConfig === C.LAYERS.GEO03E07_CP_REFRN ? this._$cpCanvas : this._$adrsCanvas,
                    styleConfig = layerConfig.STYLES[0];
                styleConfig.SYMBOLIZERS[0].COLOR = $canvas.closest("a").hasClass("active") ? "rgba(51,122,183,1)" : "rgba(255,255,255,1)";
                drawStyleIconCanvas($canvas[0], styleConfig);
            }.bind(this));
        }.bind(this));
    };

    _onCpFieldInputChanged(evt) {
        var $selectedOption = this._$cpFieldInput.find("option:selected");
        this._$cpValuesInput.val("").attr("placeholder", $selectedOption.attr("placeholder"));
        if ($selectedOption.attr("showNotice")) {
            this._$cpNotice.show();
        } else {
            this._$cpNotice.hide();
        }
        if ($selectedOption.attr("checkBoxInput")) {
            this._$cpCheckboxInput.closest(".checkbox").show();
        } else {
            this._$cpCheckboxInput.closest(".checkbox").hide();
            this._$cpCheckboxInput.prop("checked", "");
        }
    };

    _onAdrsFieldInputChanged(evt) {
        var $selectedOption = this._$adrsFieldInput.find("option:selected");
        this._$adrsValuesInput.val("").attr("placeholder", $selectedOption.attr("placeholder"));
        if ($selectedOption.attr("checkBoxInput")) {
            this._$adrsCheckboxInput.closest(".checkbox").show();
        } else {
            this._$adrsCheckboxInput.closest(".checkbox").hide();
            this._$adrsCheckboxInput.prop("checked", "");
        }
    };

    _onCpFormSubmitted(evt) {
        evt.preventDefault();
        if (!this._formIsSubmitting) {
            this._formIsSubmitting = true;
            var selectByField = this._$cpFieldInput.find("option:selected").attr("field-id"),
                selectByValues = this._$cpValuesInput.val();
            if (selectByValues) {
                this._$cpValuesInput.parent().removeClass("has-error");
                this._makeCpQuery(selectByField, selectByValues);
                //query adrs with cp if checkecd
                if (this._$cpCheckboxInput.prop("checked")) {
                    this._makeAdrsQuery("CODPOS", selectByValues);
                }
            } else {
                this._formIsSubmitting = false;
                show("QueryCpAdrs_SelectByValuesInputEmpty");
                this._$cpValuesInput.parent().addClass("has-error");
            }
        } else {
            show("QueryCpAdrs_formIsSubmitting");
        }
    };

    _onAdrsFormSubmitted(evt) {
        evt.preventDefault();
        if (!this._formIsSubmitting) {
            this._formIsSubmitting = true;
            var selectByField = this._$adrsFieldInput.find("option:selected").attr("field-id"),
                selectByValues = this._$adrsValuesInput.val();
            if (selectByValues) {
                this._$adrsValuesInput.parent().removeClass("has-error");
                this._makeAdrsQuery(selectByField, selectByValues);
                //query cp with adrs if checkecd
                if (this._$adrsCheckboxInput.prop("checked")) {
                    this._makeCpQuery("CD_POSTL", selectByValues);
                }
            } else {
                this._formIsSubmitting = false;
                show("QueryCpAdrs_SelectByValuesInputEmpty");
                this._$adrsValuesInput.parent().addClass("has-error");
            }
        } else {
            show("QueryCpAdrs_formIsSubmitting");
        }
    };

    _makeCpQuery(selectByField, selectByValues) {
        var layerConfig = _.cloneDeep(this._cpLayerConfig);
        layerConfig.LAYER_PROPERTIES.NAME = selectByField + " = " + selectByValues;
        layerConfig.STYLES[0].ID += _.uniqueId("_");
        layerConfig.STYLES[0].SYMBOLIZERS[0].COLOR = layerConfig.STYLES[0].STYLE_LABEL_PROPERTIES.COLOR = "rgba(" + _.random(0,255) + "," + _.random(0,255) + "," + _.random(0,255) + ", 1)";
        layerConfig.QUERY_EXPRESSION.QUERIES[0].FIELD = selectByField;
        layerConfig.QUERY_EXPRESSION.QUERIES[0].VALUE = _.split(_.toUpper(_.replace(selectByValues, /[^0-9a-zA-Z,]/g, "")), ",");
        this._queryData(layerConfig);
    };

    _makeAdrsQuery(selectByField, selectByValues) {
        var layerConfig = _.cloneDeep(this._adrsLayerConfig);
        layerConfig.LAYER_PROPERTIES.NAME = selectByField + " = " + selectByValues;
        layerConfig.STYLES[0].ID += _.uniqueId("_");
        layerConfig.STYLES[0].SYMBOLIZERS[0].COLOR = layerConfig.STYLES[0].STYLE_LABEL_PROPERTIES.COLOR = "rgba(" + _.random(0,255) + "," + _.random(0,255) + "," + _.random(0,255) + ", 1)";
        layerConfig.QUERY_EXPRESSION.QUERIES[0].FIELD = selectByField;
        layerConfig.QUERY_EXPRESSION.QUERIES[0].VALUE = _.split(_.toUpper(_.replace(selectByValues, /[^0-9a-zA-Z,]/g, "")), ",");
        this._queryData(layerConfig);
    };

    _queryData(layerConfig) {
        show("QueryCpAdrs_QueryData");
        queryLayer(layerConfig, layerConfig.QUERY_EXPRESSION, {"getFromCache": false})
            .then(function(response) {
                this._formIsSubmitting = false;
                if (response.features.length) {
                    show("QueryCpAdrs_ServerDataInitialized");
                    this._createResultFeatures(layerConfig, response);
                } else {
                    show("QueryCpAdrs_QueryNotFound");
                }
            }.bind(this))
            .catch(function(error) {
                this._formIsSubmitting = false;
                show("QueryCpAdrs_QueryError");
                Promise.reject(error);
            }.bind(this));
    };

    _createResultFeatures(layerConfig, response) {
        var layer = this._map.getLayer(layerConfig.LAYER_ID),
            style = createStyle(layerConfig.STYLES[0])
        layer.addStyle(style);
        var features = createFeatures(layerConfig, response.features);
        layer.addFeatures(features);
        var dataRows = createDataRows(layerConfig, response.features, _.map(features, "id"));
        layer.getDataTable(layerConfig.DATATABLE_ID).addDataRows(dataRows);
        this._mapController.zoomOnFeatures(features, (features.length > 1 ? null : layer));
        if (layerConfig.LAYER_ID == this._cpLayerConfig.LAYER_ID) {
            this._cpResultsList.addResult(features, layerConfig.LAYER_PROPERTIES.NAME);
        } else {
            this._adrsResultsList.addResult(features, layerConfig.LAYER_PROPERTIES.NAME);
        }
    };
}

